import { Box, useMediaQuery } from "@mui/material";
import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Order for horizontal quick-filter bar
// Category values: backend DEAL_CATEGORIES (lowercase) or CUISINE_TYPES (Title Case) or TAG_TYPES (lowercase)
export const allCategories = [
  { value: "drinks", label: "🥤  Drinks" },
  { value: "healthy", label: "🥗  Healthy" },
  { value: "Fast Food", label: "🍔  Fast Food" },
  { value: "Chinese", label: "🍜  Chinese" },
  { value: "Japanese", label: "🍣  Japanese" },
  { value: "Local", label: "🍛  Local" },
  { value: "Western", label: "🍽 Western" },
  { value: "dessert", label: "🍰  Dessert" },
  { value: "Korean", label: "🍜 Korean" },
  { value: "Thai", label: "🌶️ Thai" },
  { value: "Italian", label: "🍝 Italian" },
  { value: "Snacks", label: "🍿 Snacks" },
  { value: "birthday", label: "🎂  Birthday" },
];

// Show all categories in the quick-filter horizontal bar (scrollable)
const QUICK_FILTER_COUNT = allCategories.length;

const CategoryFilter = ({
  categoryFilter,
  setCategoryFilter,
  isActive = true,
  onCategoryChange,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const location = useLocation();
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  if (!isMobile || !isActive) return null;

  return (
    <Box
      ref={scrollRef}
      sx={{
        px: 1.5,
        py: 0.5,
        overflowX: "scroll",
        overflowY: "hidden",
        WebkitOverflowScrolling: "touch",
        "&::-webkit-scrollbar": {
          display: "none",
          width: 0,
          height: 0,
        },
        "&::-webkit-scrollbar-track": {
          display: "none",
        },
        "&::-webkit-scrollbar-thumb": {
          display: "none",
        },
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          width: "max-content",
        }}
      >
        {allCategories.slice(0, QUICK_FILTER_COUNT).map((cat) => {
          const isSelected = categoryFilter === cat.value;
          return (
            <Box
              key={cat.value}
              onClick={() => {
                const newCategory =
                  categoryFilter === cat.value ? "" : cat.value;

                setCategoryFilter(newCategory);

                // Scroll the deal list back to the top
                if (onCategoryChange) onCategoryChange();

                const urlParams = new URLSearchParams(location.search);
                if (newCategory) {
                  urlParams.set("category", newCategory);
                } else {
                  urlParams.delete("category");
                }
                urlParams.delete("cuisine");
                urlParams.delete("occasion");

                navigate(`${location.pathname}?${urlParams.toString()}`);
              }}
              sx={{
                cursor: "pointer",
                background: "transparent",
                color: isSelected ? "#000" : "#999",
                borderRadius: "20px",
                px: 1.5,
                py: 0.75,
                height: "32px",
                display: "flex",
                alignItems: "center",
                fontSize: "14px",
                fontWeight: 500,
                whiteSpace: "nowrap",
                flexShrink: 0,
                transition: "all 0.2s ease",
                border: "none",
              }}
            >
              {cat.label}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default CategoryFilter;
